import { watch, onBeforeUnmount } from 'vue';
import { useCountdown } from '@/shared/common/composables/useCountdown';

interface Props {
  show: boolean;
  timeRemaining: number;
}

type EmitFn = {
  (e: 'extend-session'): void;
  (e: 'close-session'): void;
};

/**
 * Composable para manejar la lógica del componente SessionExpirationAlert.
 * @param props - Props del componente
 * @param emit - Función para emitir eventos
 * @returns Estado y funciones del componente
 */
export function useSessionExpirationAlert(props: Props, emit: EmitFn) {
  const { countdownMinutes, countdownSeconds, initCountdown, stopCountdown } = useCountdown();

  function handleExtendSession(): void {
    emit('extend-session');
  }

  function handleCloseSession(): void {
    emit('close-session');
  }

  watch(
    () => props.show,
    (isVisible) => {
      if (isVisible && props.timeRemaining > 0) {
        initCountdown(props.timeRemaining);
      } else {
        stopCountdown();
      }
    },
    { immediate: true }
  );

  watch(
    () => props.timeRemaining,
    (remaining) => {
      if (props.show && remaining > 0) {
        initCountdown(remaining);
      }
    }
  );

  onBeforeUnmount(() => {
    stopCountdown();
  });

  return {
    countdownMinutes,
    countdownSeconds,
    handleExtendSession,
    handleCloseSession,
  };
}

